module.exports = __webpack_public_path__ + "3a1c67d5bd993670e0e0153890a777ed.svg";